import React from "react";
import {
  Container,
  HeaderTable0,
  HeaderTable1,
  HeaderTable2,
  HeaderTable3,
  HeaderTable4,
  HeaderTable5,
} from "./styles";

const HeaderTable = () => {
  return (
    <Container>
      <HeaderTable0 />
      <HeaderTable1>Nome</HeaderTable1>
      <HeaderTable2>E-mail</HeaderTable2>
      <HeaderTable3>Função</HeaderTable3>
      <HeaderTable4>Status</HeaderTable4>
      <HeaderTable5>Mais</HeaderTable5>
    </Container>
  );
};

export default HeaderTable;
